/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Access_Empty2Inputs */

const en_coinvestments_draftemail_access_empty2 = /** @type {(inputs: Coinvestments_Draftemail_Access_Empty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add recipients above — LP users will appear here for access.`)
};

/**
* | output |
* | --- |
* | "Add recipients above — LP users will appear here for access." |
*
* @param {Coinvestments_Draftemail_Access_Empty2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_access_empty2 = /** @type {((inputs?: Coinvestments_Draftemail_Access_Empty2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Access_Empty2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_access_empty2(inputs)
});
export { coinvestments_draftemail_access_empty2 as "coInvestments_draftEmail_access_empty" }